import { ImageURLData, UseMultipleChartsType } from '@ecosystem/export-utils';
import { ExportPngInfo } from '@ecosystem/newron-client-collections';

export const exportPowerPointImages =
  (multipleChartsExport: { exportCallbacks: UseMultipleChartsType }, onExportAfter?: () => void) => async () => {
    const exportResults: ExportPngInfo = {
      images: [],
    };
    const invokeExportPromises = multipleChartsExport.exportCallbacks.map(({ invokeExport }) => invokeExport?.());

    const images = await Promise.all(invokeExportPromises);

    const filteredImages = images.filter((image): image is ImageURLData => !!image);
    exportResults.images.push(...filteredImages);

    onExportAfter?.();

    return exportResults;
  };
